import moment from 'moment';
import React from 'react';
import { createContextForController } from 'react-controller-context';

const useController = () => {
    //  we want to select mon-fri of a week.  If it is wed, or after, then go to next monday

    const todaysWeekDay = moment().day();
    const defaultStartDate = todaysWeekDay <= 3 ? moment().day('Monday').startOf('day') : moment().add(1, 'week').day('Monday').startOf('day');
    const defaultEndDate = moment(defaultStartDate).day('friday').startOf('day');

    const [ startDate, setStartDate ] = React.useState(defaultStartDate.format('YYYY-MM-DD'));
    const [ endDate, setEndDate ] = React.useState(defaultEndDate.format('YYYY-MM-DD'));

    //  Set end date to 5 days after start date
    React.useEffect(() => {
        setEndDate(moment(startDate).day('friday').startOf('day').format('YYYY-MM-DD'));
    }, [startDate]);

    return {
        startDate,
        setStartDate,
        endDate,
        setEndDate
    };
};

const filtersContext = createContextForController(useController);
export const FiltersProvider = filtersContext.Provider;
export const useFilters = filtersContext.useController;